import { useEffect, useState } from 'react';

import { useInView } from 'react-intersection-observer';

export const useAmbientInfiniteScroll = (
  hasNextPage: boolean | undefined,
  isLoading: boolean,
  fetchNextPage: () => void,
  scrollContainerRef: React.RefObject<HTMLElement | null>,
) => {
  const [root, setRoot] = useState<HTMLElement | null>(null);

  // When scrollContainerRef becomes available, update the root
  useEffect(() => {
    if (scrollContainerRef.current) {
      setRoot(scrollContainerRef.current);
    }
  }, [scrollContainerRef]);

  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { ref, inView } = useInView({
    root, // will be null on first render but updated in effect
    rootMargin: '0px',
    threshold: 0.5,
  });

  useEffect(() => {
    if (inView && !isLoading && hasNextPage) {
      fetchNextPage();
    }
  }, [inView, fetchNextPage, isLoading, hasNextPage]);

  return { ref };
};
